import React from 'react';
import { Card, Row, Col, Space, Typography } from 'antd';
import { findIntersectingPositions } from "../utils";

const PositionCard = ({ title, items, ownership }) => {
  return (
    <Card
        title={<Typography.Title level={4}>{title}</Typography.Title>}
        bordered={false}
        extra={<Typography.Title level={4}>{items.length} {items.length > 1 ? 'Stocks' : 'Stock'}</Typography.Title>}
        style={{ margin: '10px', borderBottom: '1px solid #000', borderRadius: 0 }}
        className={'gapless-y'}
    >
      <div className={'pb-3'}>
        <div><b>ETFs Include</b> {ownership.map(x=><Typography.Link style={{padding: '0 3px', fontWeight: '600'}} strong>{x.toUpperCase()}</Typography.Link>)}</div>
      </div>
      <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
          {items.map((item, index) => (
            <div key={index} style={{ width: '50%', padding: '2px 5px' }}>
                <b>{index + 1})</b> {item.toUpperCase()}
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};


const EtfIntersections = ({ positions }) => {
    const intersectingPositions = findIntersectingPositions(positions);
  return (
    <Row  gutter={16} style={{ padding: '20px' }}>
      {intersectingPositions.map((item, index) => (
        <Col span={12} offset={6} key={index}>
          <PositionCard
            title={`Stocks Owned by ${item.key} ETFs`}
            items={item.symbols}
            ownership={item.ownership}
          />
        </Col>
      ))}
    </Row>
  );
};

export default EtfIntersections